/*
 *  Example data of activeCollection:
 *
 *  addSelector: '#add-clienst-limit',
 *  containerSelector: '#client-limits-collection-container',
 *  prototypeHtml: clientLimitEditPrototype,
 *  itemContainer: '.client-limit-item-container',
 *  deleteSelector: '.delete-client-limit-item-container',
 */

global.activeCollection = function activeCollection(data) {
    if (data.addSelector) {
        $('body').on('click', data.addSelector, function () {
            $(data.containerSelector).append(data.prototypeHtml.replaceAll('__id__', makeId()))
        })
    }

    if (data.deleteSelector) {
        $('body').on('click', data.deleteSelector, function () {
            $(this).closest(data.itemContainer).remove();
        });
    }
}
